import { DIAS_DE_COOKIE } from '@mc/socios'
import { Check, Copy } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

import { Boton } from '../componentes/ui'

/** Copia al portapapeles y dice «Copiado» dos segundos. Si el navegador no deja, selecciona el texto para que se copie a mano. */
export const useCopiar = () => {
  const [copiado, setCopiado] = useState(false)
  const temporizador = useRef<number | null>(null)
  useEffect(() => () => {
    if (temporizador.current) window.clearTimeout(temporizador.current)
  }, [])
  const copiar = async (texto: string) => {
    try {
      await navigator.clipboard.writeText(texto)
      setCopiado(true)
      if (temporizador.current) window.clearTimeout(temporizador.current)
      temporizador.current = window.setTimeout(() => setCopiado(false), 2000)
      return true
    } catch {
      return false
    }
  }
  return { copiado, copiar }
}

/**
 * El enlace del socio, con el botón de copiar y su código debajo. Es la misma caja
 * en la pantalla y en el diálogo de la cabecera: el enlace tiene que verse igual en
 * los dos sitios, porque es lo que el socio va a reconocer.
 */
export const CajaDeEnlace = ({ enlace, codigo, compacta = false }: { codigo: string; compacta?: boolean; enlace: string }) => {
  const { copiado, copiar } = useCopiar()
  const entrada = useRef<HTMLInputElement>(null)
  return (
    <div>
      <div className="flex flex-col gap-2 rounded-caja border border-violeta-borde bg-violeta-suave p-3 sm:flex-row sm:items-center">
        <input
          aria-label="Tu enlace de socio"
          className="campo h-9 min-w-0 flex-1 rounded-campo border border-violeta-borde bg-papel px-3 font-mono text-[13px] text-tinta"
          onFocus={(e) => e.target.select()}
          readOnly
          ref={entrada}
          value={enlace}
        />
        <Boton
          icono={copiado ? <Check /> : <Copy />}
          onClick={async () => {
            if (!(await copiar(enlace))) entrada.current?.select()
          }}
          tipo="primario"
        >
          {copiado ? 'Copiado' : 'Copiar enlace'}
        </Boton>
      </div>
      {!compacta && (
        <p className="mt-2 text-[13px] text-tenue">
          Tu código es <span className="font-mono font-medium text-tinta">{codigo}</span>. Quien entre por tu enlace queda como tuyo durante {DIAS_DE_COOKIE} días, aunque cree su cuenta otro día.
        </p>
      )}
    </div>
  )
}
